import InfoIcon from "@material-ui/icons/Info";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import { IRoute } from "src/common/typings/routes";
import { Listing } from "./pages/Vehicle/index";
import { Listing as contanerYard } from "./pages/container/index";
import { YardManagement } from "./Yard";

export const YardRoute: IRoute = {
  title: "Yard Management",
  path: "/nod/yard",
  icon: LocalParkingIcon,
  component: YardManagement,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Listing, path: "/vehicle", title: "Vehicle Yard" },
    { icon: InfoIcon, component: contanerYard, path: "/container", title: "Container Yard" },
  ],
};
